/* carrusel.js — las categorías se desplazan en horizontal y el recorrido es INFINITO:
   al llegar al final vuelve a empezar, sin salto visible.

   Cómo: se clonan los elementos hasta tener 3 tandas y se arranca en la del medio. Cuando el
   scroll entra en la tanda 3 se resta el ancho de una tanda; si retrocede hasta la 1, se suma.
   Como las tandas son idénticas, el ojo no percibe el salto — pero se puede girar sin fin en
   los dos sentidos.

   Solo se activa si las categorías NO caben: con pocas se quedan centradas y quietas, que es
   lo correcto. Y usa scroll nativo, así que en el móvil se desliza con el dedo. */
(function () {
  var nav = document.getElementById('chips-categorias');
  if (!nav) return;

  var originales = [].slice.call(nav.children);
  if (originales.length < 2) return;

  var anchoTanda = 0, ajustando = false, clonado = false;

  function medir() {
    var w = 0;
    originales.forEach(function (el) {
      var st = window.getComputedStyle(el);
      w += el.offsetWidth + parseFloat(st.marginLeft || 0) + parseFloat(st.marginRight || 0);
    });
    // el gap del flex no entra en offsetWidth: se suma aparte
    var gap = parseFloat(window.getComputedStyle(nav).columnGap || window.getComputedStyle(nav).gap || 0) || 0;
    return w + gap * originales.length;
  }

  function clonar() {
    if (clonado) return;
    for (var t = 0; t < 2; t++) {
      originales.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('data-clon', '1');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');   // el teclado solo recorre los originales
        nav.appendChild(c);
      });
    }
    clonado = true;
  }

  function activar() {
    anchoTanda = medir();
    var cabe = anchoTanda <= nav.clientWidth + 8;
    nav.classList.toggle('bucle', !cabe);
    if (cabe) return;
    clonar();
    anchoTanda = medir();
    if (nav.scrollLeft < 2) {
      nav.style.scrollBehavior = 'auto';
      nav.scrollLeft = anchoTanda;          // arranca en la tanda del medio
      nav.style.scrollBehavior = '';
    }
  }

  nav.addEventListener('scroll', function () {
    if (!clonado || ajustando || !anchoTanda) return;
    var x = nav.scrollLeft;
    if (x >= anchoTanda * 2 || x <= 0) {
      ajustando = true;
      nav.style.scrollBehavior = 'auto';
      nav.scrollLeft = x >= anchoTanda * 2 ? x - anchoTanda : x + anchoTanda;
      nav.style.scrollBehavior = '';
      // se libera en el siguiente frame: si no, el propio ajuste vuelve a disparar el handler
      window.requestAnimationFrame(function () { ajustando = false; });
    }
  }, { passive: true });

  // Flechas (útiles en escritorio; en móvil sobra el dedo)
  [].forEach.call(document.querySelectorAll('[data-cat-flecha]'), function (b) {
    b.addEventListener('click', function () {
      var paso = Math.max(140, Math.round(nav.clientWidth * 0.6));
      nav.scrollBy({ left: b.getAttribute('data-cat-flecha') === 'izq' ? -paso : paso,
                     behavior: 'smooth' });
    });
  });

  activar();
  window.addEventListener('resize', function () {
    anchoTanda = medir() / (clonado ? 3 : 1);
    activar();
  });
  // Las fuentes cambian los anchos al cargar: se vuelve a medir cuando terminan.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(activar);
})();
